import { BreadcrumbsMap } from '../../components/breadcrumbs';

export const suggestionsBreadcrumbs: BreadcrumbsMap = {
  '/suggestions': 'User suggestions',
};
